import type { PageName } from 'src/core/utils/pageUtil';

export const AnalyticsPageSections: Record<PageName, string | undefined> = {
  CommunityHome: 'community',
  CommunityAllGroups: 'community all groups',
  CommunityMyGroups: 'community my groups',
  CommunityTopGroups: 'community top groups',
  CommunityGroupDetails: 'threads',
  CommunityThreadDetails: undefined,
  unknown: undefined,
} as const;

export type AnalyticsPageSections =
  (typeof AnalyticsPageSections)[keyof typeof AnalyticsPageSections];

export const AnalyticsPageViewEvents: Record<PageName, string | undefined> = {
  CommunityHome: 'seekmax_displayed',
  CommunityAllGroups: 'discover_all_groups_displayed',
  CommunityMyGroups: 'discover_my_groups_displayed',
  CommunityTopGroups: 'discover_top_groups_displayed',
  CommunityGroupDetails: 'seekmax_category_displayed',
  CommunityThreadDetails: 'seekmax_view_thread_displayed',
  unknown: undefined,
};

export type AnalyticsEvents =
  | 'LikeThreadClick'
  | 'LikeCommentClick'
  | 'FollowGroupClick'
  | 'ShareThreadClick'
  | 'MoreThreadComment'
  | 'ShowReplies'
  | 'HideReplies'
  | 'ThreadPollClick'
  | 'LoginDialogDisplay'
  | 'SignInClick'
  | 'AppBannerClick'
  | 'CommentClick'
  | 'CommentSubmit'
  | 'ReplyClick'
  | 'ReplySubmit'
  | 'ReportClick'
  | 'CreateThreadClick'
  | 'PostThread'
  | 'DiscardPostThread';

export const AnalyticsInteractions: Record<
  AnalyticsEvents,
  { interaction: string; event: string }
> = {
  LikeThreadClick: {
    interaction: 'Like Thread Click',
    event: 'like_button_pressed',
  },
  LikeCommentClick: {
    interaction: 'Like Comment Click',
    event: 'like_button_pressed',
  },
  FollowGroupClick: {
    interaction: 'Follow Group Click',
    event: 'follow_button_pressed',
  },
  ShareThreadClick: {
    interaction: 'Share Thread Click',
    event: 'share_pressed',
  },
  MoreThreadComment: {
    interaction: 'More Thread Comment Click',
    event: 'show_more_comments_pressed',
  },
  ShowReplies: {
    interaction: 'Show Reply Pressed',
    event: 'show_reply_pressed',
  },
  HideReplies: {
    interaction: 'Hide Reply Pressed',
    event: 'hide_reply_pressed',
  },
  ThreadPollClick: {
    interaction: 'Thread Poll Click',
    event: 'poll_option_selection_pressed',
  },
  LoginDialogDisplay: {
    interaction: 'Login Dialog Display',
    event: 'careerhub_dialog_displayed',
  },
  SignInClick: {
    interaction: 'Sign In Click',
    event: 'careerhub_dialog_pressed',
  },
  AppBannerClick: {
    interaction: 'Open the app',
    event: 'careerhub_download_app_pressed',
  },
  CommentClick: {
    interaction: 'Comment button click',
    event: 'seekmax_comment_thread_start_pressed',
  },
  CommentSubmit: {
    interaction: 'Post comment',
    event: 'seekmax_comment_thread_post_succeeded',
  },
  ReplyClick: {
    interaction: 'Reply button click',
    event: 'comment_pressed',
  },
  ReplySubmit: {
    interaction: 'Post reply',
    event: 'comment_succeeded',
  },
  ReportClick: {
    interaction: 'Report button click',
    event: 'report_pressed',
  },
  CreateThreadClick: {
    interaction: 'Create thread button click',
    event: 'seekmax_create_thread_post_pressed',
  },
  PostThread: {
    interaction: 'Post thread',
    event: 'seekmax_create_thread_post_succedeed',
  },
  DiscardPostThread: {
    interaction: 'Discard post thread',
    event: 'nudge_pressed',
  },
} as const;
